// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".criteria-factor[data-v-3f91618e]{width:156px;height:48px;padding-left:var(--spacer-half);padding-right:.375rem}.criteria-factor .criteria-factor-label[data-v-3f91618e]{margin-left:.375rem;font-size:13px;letter-spacing:.25px;line-height:13px;color:var(--v-gray-ultra-dark)}", ""]);
// Exports
module.exports = exports;
